import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import './api-key-styles.css';
import './styles/waterfall.css';
import './styles/search.css';

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App />);
